import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <section className="py-12 px-4 bg-matrix-surface border-y border-matrix-dim" data-id="element-43">
      <div className="max-w-5xl mx-auto" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-matrix-orange mb-10 text-center" data-id="element-45">
          Para quién es (y para quién no)
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-46">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-47">
            <h3 className="text-xl font-bold text-matrix-primary mb-6 flex items-center gap-2" data-id="element-48">
              <Check className="w-6 h-6" data-id="element-49" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-50">
              {["Sientes que 'te vas' de tu vida en el teléfono", 'Quieres espiritualidad aterrizada (presencia con estructura)', 'Estás listo para 30 días de regreso real, no perfecto'].map((item, i) => <li key={i} className="flex items-start gap-3 text-matrix-text/90" data-id="element-51">
                  <div className="w-1.5 h-1.5 rounded-full bg-matrix-primary mt-2.5 shrink-0" data-id="element-52" />
                  <span data-id="element-53">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-54">
            <h3 className="text-xl font-bold text-matrix-red mb-6 flex items-center gap-2" data-id="element-55">
              <X className="w-6 h-6" data-id="element-56" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-57">
              {['Buscas una solución mágica sin tocar tus hábitos', "Quieres un 'detox' extremo de moda para presumir", 'No estás dispuesto a proteger ni un solo umbral'].map((item, i) => <li key={i} className="flex items-start gap-3 text-matrix-muted" data-id="element-58">
                  <div className="w-1.5 h-1.5 rounded-full bg-matrix-red mt-2.5 shrink-0" data-id="element-59" />
                  <span data-id="element-60">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}